import { getDateInFormat } from "@domains/utils/reportDates";
export var revenueFnoMarginMapper = function (data) {
    var revenueFnoMarginEntity = {
        fnoDetails: [],
    };
    if (data && data.length > 0) {
        data.map(function (record) {
            var revenueFnoMarginObj = {
                dpcMonth: record.dpC_Month,
                value: record.value,
                id: record.id,
                fnoMonthwiseDetails: [],
            };
            if (record.fnodetails && record.fnodetails.length > 0) {
                revenueFnoMarginObj.fnoMonthwiseDetails = record.fnodetails.map(function (record) {
                    return {
                        trxdate: getDateInFormat(record.trxdate, "DD-MM-YYYY"),
                        exchngMarginReq: record.exchngMarginReq,
                        halfExchngMarginReq: record.halfExchngMarginReq,
                        availableCashMargin: record.availableCashMargin,
                        availableCashEQ: record.availableCashEQ,
                        dpcChargeableAmount: record.dpC_Chargeable_Amount,
                        dpcChargesPercentage: record.dpC_Charges_Percentage,
                        dpcPerday: record.dpC_Perday,
                        id: record.id,
                    };
                });
            }
            revenueFnoMarginEntity.fnoDetails.push(revenueFnoMarginObj);
        });
    }
    return revenueFnoMarginEntity;
};
